import type { MarketResult } from "./getMarketSettlement";

export const RESOLVED_LABEL = "Resolved";
export const RESULT_NOT_AVAILABLE_LABEL = "Result not available";
export const CLOSED_LABEL = "Closed";
export const VARIES_LABEL = "Varies";
export const UMA_DISPUTED_LABEL = "UMA disputed";
// The list row's Ends in while a market waits on UMA (mock).
export const DISPUTED_LABEL = "Disputed";
export const ACTIVE_UNTIL_RESOLUTION_LABEL = "Active until resolution";
export const AWAITING_RESOLUTION_LABEL = "Awaiting resolution";
export const NOT_YET_RESOLVED_LABEL = "Not yet resolved";
export const UMA_DISPUTED_TOOLTIP =
  "The proposed result was challenged on the platform's oracle (UMA). The market stays open until the dispute is settled, so the price can still move.";
export const CLOSED_LIQUIDITY_TOOLTIP = "Trading closed at resolution.";
export const CLOSED_OUTCOME_LIQUIDITY_TOOLTIP =
  "Trading closed at resolution, so there is no order book left.";
export const FINAL_RESULT_TOOLTIP =
  "Final result. Trading is closed; winning shares redeem at 100¢ on the platform.";
export const MIXED_RESULT_TOOLTIP =
  "Platforms resolved this market differently. Winning shares redeem at 100¢ on each platform according to its own result.";
export const DISPUTED_LIQUIDITY_TOOLTIP = {
  reported: "Liquidity still on the book while the dispute is open.",
  none: "No liquidity reported while the dispute is open.",
};

export const RESULT_WORD: Record<MarketResult, string> = {
  yes: "Yes",
  no: "No",
};
